import { STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import {
    type IInfoGroup,
    type IInfoGroupConfiguration,
    type IInfoGroupField,
    type IInfoGroupFieldConfiguration,
    infoGroupsManager
} from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { INFO_GROUP_CONFIGURATION_MODULE } from '../infogroup-configuration-module';
import { INFO_GROUP_FIELD_CONFIGURATION_MODULE } from '../infogroup-field-configuration-module';
import { RECEIVE_INFO_GROUPS } from './mutations';
import { type InfoGroupsResult } from './types';

export const RETRIEVE_INFO_GROUPS = 'retrieveInfoGroups';

export const actions: ActionTree<InfoGroupsResult, unknown> = {
    async [RETRIEVE_INFO_GROUPS](context) {
        const result = await infoGroupsManager.getAllInfoGroups();
        const infoGroupConfigs =
            result
                ?.filter((infoGroup) => {
                    return infoGroup.configuration !== null && infoGroup.configuration !== undefined;
                })
                .map((filteredInfoGroup) => {
                    return filteredInfoGroup.configuration;
                }) ?? [];
        result.forEach((infogroup) => {
            infogroup.configuration = (infogroup.configuration as unknown as IInfoGroupConfiguration)?.dobjId;
        });

        result.forEach((infoGroup: IInfoGroup) => {
            const infoGroupFieldsConfigurations =
                infoGroup.fields
                    ?.filter((infoGroupField: IInfoGroupField) => {
                        return infoGroupField.configuration !== null && infoGroupField !== undefined;
                    })
                    .map((filteredInfoGroupField: IInfoGroupField) => {
                        return filteredInfoGroupField.configuration;
                    }) ?? [];
            infoGroup.fields.forEach((infogroupField) => {
                infogroupField.configuration = (infogroupField.configuration as unknown as IInfoGroupFieldConfiguration)?.dobjId;
            });

            if (infoGroupFieldsConfigurations.length > 0) {
                void context.dispatch(
                    `${INFO_GROUP_FIELD_CONFIGURATION_MODULE}/${STORE_DATA_OBJECTS}`,
                    { infogroupType: infoGroup.infogroupType, dataObjectList: infoGroupFieldsConfigurations },
                    { root: true }
                );
            }
        });

        if (infoGroupConfigs.length > 0) {
            void context.dispatch(`${INFO_GROUP_CONFIGURATION_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: infoGroupConfigs }, { root: true });
        }

        context.commit(RECEIVE_INFO_GROUPS, { infoGroups: result });
    }
};
